/**
 * ACADEMIA · «FORMACIÓN INTEGRAL DENTRO Y FUERA DE LA CANCHA»
 * =============================================================================
 * La fotografía ocupa la pantalla completa, con el texto encima, igual que la
 * portada. Debajo van la tira de los cuatro valores y los bloques de misión y
 * visión.
 */

import { CONFIG } from '../config';
import { PantallaCompleta } from '../componentes/PantallaCompleta';
import { Icono, IconoEnAro, type NombreIcono } from '../componentes/Iconos';
import { Revelar } from '../componentes/Piezas';
import { useIdioma } from '../i18n/useIdioma';

export function Academia() {
  const { textos } = useIdioma();
  const t = textos.academia;

  const irA = (id: string) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <>
      <PantallaCompleta
        id="academia"
        foto={CONFIG.fotos.portadaAcademia}
        alt={t.fotoAlt}
        etiqueta={t.etiqueta}
        tituloMedio
        titulo={
          <>
            {t.titulo1}
            <br />
            <span className="oro">{t.titulo2}</span>
          </>
        }
        texto={t.texto}
        /* El sujeto está en la mitad de arriba, así que se sube el encuadre. En el
           teléfono todavía más, porque el recorte se estrecha. */
        encuadre="50% 26%"
        encuadreMovil="50% 18%"
      >
        <div className="acciones-fila">
          <button type="button" className="boton boton--marco" onClick={() => irA('metodologia')}>
            <span>{t.boton}</span>
            <Icono nombre="flecha" tam={16} />
          </button>
        </div>
      </PantallaCompleta>

      {/* Los valores y la mision van en su propio bloque, con el fondo de la
          pagina. Antes estaban sueltos y quedaban pegados a la fotografia. */}
      <section className="seccion seccion--valores">
        <div className="caja">
        <Revelar>
          <div className="tira-iconos">
            {t.valores.map((v) => (
              <div className="tira-iconos__item" key={v.titulo}>
                <IconoEnAro nombre={v.icono as NombreIcono} tam={54} grosorIcono={22} />
                <span className="tira-iconos__texto">{v.titulo}</span>
              </div>
            ))}
          </div>
        </Revelar>

        <Revelar>
          <div className="mision-vision">
            <figure className="mision-vision__foto">
              <img
                src={CONFIG.fotos.academiaMision}
                alt={textos.academia.fotoAltMision}
                loading="lazy"
                decoding="async"
                style={{ objectPosition: '50% 30%' }}
              />
            </figure>

            <div className="mision-vision__bloques">
              <div className="mision-vision__bloque">
                <h3 className="mision-vision__titulo">
                  {t.misionEtiqueta} <span className="oro">{t.misionTitulo}</span>
                </h3>
                <p className="mision-vision__texto">{t.mision}</p>
              </div>

              <div className="mision-vision__bloque">
                <h3 className="mision-vision__titulo">
                  {t.visionEtiqueta} <span className="oro">{t.visionTitulo}</span>
                </h3>
                <p className="mision-vision__texto">{t.vision}</p>
              </div>
            </div>
          </div>
        </Revelar>
        </div>
      </section>
    </>
  );
}